struct Params_std140_0
{
    @align(16) worldSize_0 : vec2<f32>,
    @align(8) viewSize_0 : vec2<f32>,
    @align(16) gridSize_0 : vec2<f32>,
    @align(8) dotSize_0 : vec2<f32>,
    @align(16) fieldUvScale_0 : vec2<f32>,
    @align(8) pointer_0 : vec2<f32>,
    @align(16) pointerRadius_0 : f32,
    @align(4) pointerForce_0 : f32,
    @align(8) particleCount_0 : f32,
    @align(4) binCount_0 : f32,
    @align(16) binSize_0 : f32,
    @align(4) returnForce_0 : f32,
    @align(8) returnDamping_0 : f32,
    @align(4) dt_0 : f32,
    @align(16) mu_k_0 : f32,
    @align(4) sigma_k_0 : f32,
    @align(8) w_k_0 : f32,
    @align(4) mu_g_0 : f32,
    @align(16) sigma_g_0 : f32,
    @align(4) c_rep_0 : f32,
    @align(8) r_rep_0 : f32,
    @align(4) resetAttempts_0 : f32,
    @align(16) initialFieldScattering_0 : f32,
};

@binding(0) @group(0) var<uniform> data_params_0 : Params_std140_0;
@binding(1) @group(0) var<storage, read> data_source_0 : array<u32>;

@binding(2) @group(0) var<storage, read_write> data_destination_0 : array<u32>;

@binding(3) @group(0) var<uniform> data_stepSize_0 : u32;
@compute
@workgroup_size(64, 1, 1)
fn prefixSum(@builtin(global_invocation_id) gid_0 : vec3<u32>)
{
    var _S1 : u32 = gid_0.x;
    if(f32(_S1) >= (data_params_0.binCount_0 + 1.0f))
    {
        return;
    }
    var _S2 : u32 = data_stepSize_0;
    if(_S1 < data_stepSize_0)
    {
        data_destination_0[_S1] = data_source_0[_S1];
    }
    else
    {
        data_destination_0[_S1] = data_source_0[_S1 - _S2] + data_source_0[_S1];
    }
    return;
}

